import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-resource-information',
  templateUrl: './resource-information.component.html',
  styleUrls: ['./resource-information.component.scss']
})
export class ResourceInformationComponent{
  @Input() title: string = "";
  @Input() description: string = "";
  @Input() chartData: Array<{ name: string, value: number }> = [];
  @Input() doughnutDescription: string = "";
  @Input() doughnutHeight = 140;
  @Input() doughnutWidth = 140;
}
